import { TUNNEL_STATUS_CODES } from "./tunnel-status.js";
import { z } from "zod";
//#region src/tunnel-status.schemas.ts
/**
* The zod rules of the tunnel status contract (plan 2026-10-27-cp-dp-network-path, WS-2). The
* types, the constants and the pure functions are in `tunnel-status.ts`; this file holds the runtime
* validation, which is this package's convention. `tunnel-status.test.ts` holds each rule equal to
* its type at compile time. No rule here uses `.transform()`.
*/
/** A tunnel status code: one of `TUNNEL_STATUS_CODES`, exact case. */
const TunnelStatusCodeSchema = z.enum(TUNNEL_STATUS_CODES);
/**
* The JSON body of a tunnel status: `error` is the code and `message` a text of 1 to
* `TUNNEL_STATUS_MESSAGE_MAX` (512) characters. Strict: an unknown key fails. A CP client parses
* a body with it after `readTunnelStatus` answered a code.
*/
const TunnelStatusBodySchema = z.object({
	error: TunnelStatusCodeSchema,
	message: z.string().min(1).max(512)
}).strict();
//#endregion
export { TunnelStatusBodySchema, TunnelStatusCodeSchema };

//# sourceMappingURL=tunnel-status.schemas.js.map